import { render, staticRenderFns } from "./SuccessStep.vue?vue&type=template&id=0b13f07e&scoped=true"
import script from "./SuccessStep.vue?vue&type=script&lang=js"
export * from "./SuccessStep.vue?vue&type=script&lang=js"
import style0 from "./SuccessStep.vue?vue&type=style&index=0&id=0b13f07e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13f07e",
  null
  
)

export default component.exports